export default __webpack_public_path__ + "static/media/what_the_hell_blazing_saddles.13915cab.gif";